import React from "react";
import Logo from "./Logo";
import { GetImages } from "../utils/GetImages";
import UserName from "./UserName";
import { useMenu } from "../utils/context/MenuContext";
import "./appBar.css";
import { useTheme } from "../utils/context/ThemeContext";
import { Sun, Moon } from "lucide-react";

const CustomTopBar: React.FC<{ size: number, userRoleId: string, showUserName: boolean }> = ({ size, userRoleId, showUserName = true }) => {
  const { isHidden, setIsHidden, isOpen, setIsOpen } = useMenu();
  const { theme, toggleTheme } = useTheme();

  return (
    <div style={{zIndex: size > 400 ? 100 : 50, }} className="appBarMainBox" >
      <div>
        {size < 400 ? (
          <div className="d-flex align-items-center justify-content-center p-3 ">
            <img
              onClick={() => {
                setIsHidden(!isHidden);
                setIsOpen(true);
              }}
              className="pe-3"
              src={GetImages.alreadyCollapsed}
            />
            <img src={GetImages.leftSideLogoSmall} />
            <img src={GetImages.rightSideLogoSmall} />
          </div>
        ) : (
          <Logo />
        )}
      </div>
      <div className="rightSideButtons d-flex align-items-center gap-3">
        <button
          onClick={toggleTheme}
          className="btn p-2 rounded-circle"
          style={{ background: 'transparent', border: 'none' }}
          title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
          {theme === "light" ? <Moon size={20} color="#667085" /> : <Sun size={20} color="#f9fafb" />}
        </button>
        {showUserName && <UserName size={size} userRoleId={userRoleId} />}
      </div>
    </div>
  );
};

export default CustomTopBar;
